import Request from './request';
// import consts from "@/consts.js";

async function fetch(data) {
    return Request('get', "api/wave-rulers/", data);
}

async function fetchOne(id) {
    return Request('get', "api/wave-rulers/view/" + id);
}

async function save(id,data) {
    if (id) {
        return Request('post', "api/wave-rulers/edit/" + id, data);
    } else {
        return Request('post', "api/wave-rulers/add", data);
    }
}

export default {
    fetch,
    fetchOne,
    save,
};